export default {
  zh: {
    aboutUs: '关于我们',
    company: 'Plex加速器由Plex Inc开发及运营，我们是一家立足中国、放眼世界的互联网科技公司。',
    concentrate: '专注于加速器服务，不限流量带宽! 用户可以在线自助付费购买，管理加速器，方便快捷。',
    wish: '我们愿景是联接中国与世界，利用移动互联网的科技力量，通过产品、技术和服务优势为全球消费者发掘最优质的商品和产品信息。',
    contactUs: '联系我们',
    email: '邮箱：'
  },
  en: {
    aboutUs: 'About Us',
    company: 'PlexVPN owned and operated by Plex Inc., which is an Internet Technology company based in Beijing, China.',
    concentrate: 'Focus on VPN service, No bandwidth charges or speed limits! ' +
    'Users can buy our service online by themselves. It is convenient for them to manage and use.',
    wish: 'Our mission is to connect China and the World, ' +
    'use the power of internet technology to provide the best goods and product ' +
    'information for global consumers through our product, technology and service advantages.',
    contactUs: 'Contact Us',
    email: 'Email: '
  }
}



// WEBPACK FOOTER //
// ./src/views/aboutUs/lang.js